// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--vz2Zy","label":"a10a3f92e9--label--3Iv5c"};